// src/components/Marquee.js
import React from 'react';
import '../styles/marquee.css';
const TECH = ['Python','Django','FastAPI','PostgreSQL','OpenAI','AWS','Docker','Redis','n8n','Airflow','MLflow','pgvector','Lambda','Celery','OCR'];
const COLORS = ['#60a5fa','#22d3ee','#818cf8','#34d399','#f59e0b'];
export default function Marquee() {
  const items = [...TECH, ...TECH];
  return (
    <div className="mq-outer">
      <div className="mq-track">
        {items.map((t,i) => (
          <div key={i} className="mq-item">
            <span className="mq-dot" style={{background: COLORS[i % COLORS.length]}}/>
            {t}
          </div>
        ))}
      </div>
    </div>
  );
}